
import React, {Component} from 'react';
import { Badge, Row, Col, InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, 
  Card, CardBody, Form, FormGroup,  FormFeedback } from 'reactstrap';


import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/ShortText';
import NavigationIcon from '@material-ui/icons/Navigation';
import Sternenbewertung from './Sternenbewertung';
import OffeneFragen from './OffeneFragen';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import {RadioGroup, Radio} from 'react-radio-group'; 

const styles = theme => ({
    fab: {
      margin: theme.spacing.unit,
    },
    extendedIcon: {
      marginRight: theme.spacing.unit,
    },
  });
  
  class RadioGroupTrueFalse extends Component {
    constructor(props) {
      super(props);
      this.state = {
       // checked: false, 
       selectedValue: false, 
      };
  
    this.handleChange = this.handleChange.bind(this)
  
    }

  
    componentDidMount(){
      this.props.callback({ index: this.props.index, val: this.state.selectedValue})
    }

   async handleChange(e){
       //await this.setState({ checked: e.target.checked })
       await this.setState({ selectedValue: e })
       this.props.callback({ index: this.props.index, val: this.state.selectedValue})
        console.log('Value of checkbox is: ', this.state.selectedValue)
    }

    render() {
    return (
        <div>
            <Container>
                <Row>
                    <Col>
                        <p>{this.props.text}</p>
                    </Col>
                    <Col>                        
                        <RadioGroup
                        name={this.props.TextField}
                        selectedValue={this.state.selectedValue}
                        onChange={this.handleChange}
                        >
                          
                        <label>
    <Radio value={true} /> {this.props.surveytype == 0 ? "Ja" : "Richtig" }
                        </label>
                        {'   '}
                        <label>
                          <Radio value={false} />{this.props.surveytype == 0 ? "Nein" : "Falsch" }
                        </label>

                        </RadioGroup>
                    </Col>
                </Row>
            </Container>
        </div>
    );
    }

}

export default withStyles(styles)(RadioGroupTrueFalse);



// WEBPACK FOOTER //
// ./src/modules/movie-browser/RadioGroupTrueFalse.js